import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import postal from 'postal';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import ErrorBoundary from '../../../../shared/error-boundary';
import AutoPublishWireModal from './auto-publish-wire-modal';
import { updateAutoPublishDate } from '../../../../services/wire/edit-services';

require('moment-timezone');

export default class AutoPublishWireControl extends React.Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    wirePublished: PropTypes.bool,
    autoPublishAt: PropTypes.string,
  }

  static defaultProps = {
    wirePublished: false,
    autoPublishAt: null,
  }

  constructor(props, context) {
    super(props, context);

    const dateTime = this.props.autoPublishAt ? moment(this.props.autoPublishAt) : null;
    const savedAutoPublishedAt = dateTime;
    this.state = { dateTime, savedAutoPublishedAt, wirePublished: this.props.wirePublished };

    this.handleDateTimeSettingsUpdated = this.handleDateTimeSettingsUpdated.bind(this);
    this.presentModal = this.presentModal.bind(this);
    this.cancelSchedule = this.cancelSchedule.bind(this);

    postal.subscribe({
      channel: 'editor',
      topic: 'wire-unpublished',
      callback: () => this.setState({ wirePublished: false }),
    });
  }

  handleDateTimeSettingsUpdated(dateTime) {
    this.setState({ dateTime });

    postal.publish({
      channel: 'editor',
      topic: 'auto-publish-time-changed',
      data: dateTime,
    });
  }

  presentModal(e) {
    e && e.preventDefault && e.preventDefault();

    this.autoPublishWireModal.present(this.state.dateTime);
  }

  cancelSchedule(evt) {
    evt && evt.preventDefault && evt.preventDefault();

    updateAutoPublishDate(this.props.wireId, null)
      .then(() => {
        this.handleDateTimeSettingsUpdated(null);
        this.setState({ savedAutoPublishedAt: null });
      })
      .catch(e => defaultOnErrorHandler(e, 'Error updating schedule settings for wire'));
  }

  render() {
    const requiresWireReview = window.Livewire?.currentUser?.profile?.requiresWireReview === 'true' || window.Livewire?.currentUser?.profile?.requiresWireReview === true;

    return !this.state.wirePublished && (
      <ErrorBoundary>
        <aside className="sidebar-item no-top-margin">
          <section className="form-group no-top-margin">
            <a href="#" className="sidebar-item-link" onClick={this.presentModal}>
              Schedule wire
            </a>
            {!!this.state.dateTime && (
              <p className="sidebar-item-schedule-text">{this.state.dateTime.tz('Australia/Sydney').format('hh:mm a LL zz')}</p>
            )}
            {!!this.state.dateTime && (
              <a href="#" className="sidebar-item-secondary-link" onClick={this.cancelSchedule}>
                {!!this.state.savedAutoPublishedAt && (<span>Cancel schedule</span>) }
                {!this.state.savedAutoPublishedAt && (<span>Clear</span>) }
              </a>
            )}
            {requiresWireReview && (
              <div
                className="help-block"
                style={{
                  marginTop: '8px',
                  color: '#666',
                  fontSize: '13px',
                  lineHeight: '1.4',
                }}
              >
                When the scheduled time arrives, your wire will be submitted for editorial review.
              </div>
            )}
          </section>
        </aside>
        <AutoPublishWireModal
          ref={el => (this.autoPublishWireModal = el)}
          wireId={this.props.wireId}
          onAutoPublishSettingsUpdated={this.handleDateTimeSettingsUpdated}
        />
      </ErrorBoundary>
    );
  }
}
